import React, {useMemo, useCallback} from 'react';
import PropTypes from 'prop-types';
import {ReviewRow, ReviewMediaRow, ReviewHtmlRow} from '../ReviewRow/ReviewRow';

const ReviewDisplayContentTab = ({
  activeLanguage,
  salesTargetData,
  isLinkedTargetType = false
}) => {
  const {displayContent, displayContentMedia, displayContentMediaOptional} =
    salesTargetData;

  const imageUri = useMemo(
    () => displayContentMedia?.imageUri || displayContentMedia?.imageUrl || '',
    [displayContentMedia]
  );
  const imageUriOptional = useMemo(
    () =>
      displayContentMediaOptional?.imageUri ||
      displayContentMediaOptional?.imageUrl ||
      '',
    [displayContentMediaOptional]
  );
  const data = useMemo(
    () => displayContent?.[activeLanguage] || {},
    [displayContent, activeLanguage]
  );

  const getAnswer = useCallback((val) => (val ? 'Yes' : 'No'), []);

  const renderMediaSection = useCallback(
    (imageUri, displayContentMedia, downloadFileName, testId) => {
      if (!imageUri || imageUri === '') return null;

      return (
        <div className='w-full md:w-1/2'>
          <div className='review_subtitle'>Media</div>
          <div className='grid grid-cols-1'>
            <div className='grid_wrap'>
              <a
                href={imageUri}
                download={downloadFileName}
                className='review_image_row grid cursor-pointer grid-cols-2 gap-y-2'>
                <img src={imageUri} alt='Pepsi Logo' />
              </a>
              <ReviewMediaRow
                data-testid={testId}
                label='Title'
                value={displayContentMedia?.title}
              />
              <ReviewMediaRow
                label='Opt In'
                value={getAnswer(displayContentMedia?.optIn)}
              />
              <ReviewMediaRow
                label='Image Type'
                value={displayContentMedia?.imageId}
              />
            </div>
          </div>
        </div>
      );
    },
    [getAnswer]
  );

  return (
    <div data-testid='ReviewdisplayContentForm'>
      <div className='review_subtitle mtb30'>Display</div>
      <div className='grid'>
        <div className='grid_wrap'>
          <ReviewRow
            data-testid='display-title-label'
            label='Title'
            value={data.title}
          />
          {isLinkedTargetType ? (
            <>
              <ReviewHtmlRow label='Description' value={data.description} />
              <ReviewHtmlRow label='Terms' value={data.terms} />
            </>
          ) : (
            <>
              <ReviewRow
                data-testid='display-category-label'
                label='Category For Target Title'
                value={data?.category}
              />
              <ReviewHtmlRow label='Excerpt' value={data.excerpt} />
              <ReviewHtmlRow label='Terms' value={data.terms} />
            </>
          )}
        </div>
      </div>
      <div className='flex flex-col gap-14 md:flex-row'>
        {renderMediaSection(
          imageUri,
          displayContentMedia,
          'display_content_image.png',
          'display-title-label'
        )}
        {renderMediaSection(
          imageUriOptional,
          displayContentMediaOptional,
          'display_content_image_optional.png',
          'display-title-label'
        )}
      </div>
    </div>
  );
};

export default React.memo(ReviewDisplayContentTab);

ReviewDisplayContentTab.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  salesTargetData: PropTypes.object.isRequired,
  isLinkedTargetType: PropTypes.bool
};
